import Vue, { DirectiveOptions } from 'vue';
import { EventBus } from '../helpers/bus';

const keepRatioOnResize = (el: HTMLElement, params: ResizeParams): any => {
    return () => {
        const ratio = el.offsetWidth / params.initialWidth;
        el.style.fontSize = `${ params.fontSize * ratio }px`;
    };
};

interface ResizeParams {
    width: number;
    height: number;
    fontSize: number;
    ratio: number;
    initialWidth: number;
    initialHeight: number;
}

const captureInitialParams = (el: HTMLElement, ratioParam: number | { width: number, height: number }): ResizeParams => {
    const computed = window.getComputedStyle(el);
    const fontSize = parseFloat(window.getComputedStyle(document.body).fontSize || '');
    return {
        fontSize,
        width: parseFloat(computed.width || ''),
        height: parseFloat(computed.height || ''),
        ratio: typeof ratioParam === 'number' ? ratioParam : ratioParam.width / ratioParam.height,
        initialWidth: typeof ratioParam === 'number' ? 0 : ratioParam.width,
        initialHeight: typeof ratioParam === 'number' ? 0 : ratioParam.height,
    };
};

let callback: any = null;

const keepRatio: DirectiveOptions = {
    bind: (el, { value }): void => {
        document.addEventListener('DOMContentLoaded', () => {
            const params = captureInitialParams(el, value);
            callback = keepRatioOnResize(el, params);
            EventBus.$on('windowResize', callback);
            EventBus.$on('orientationChange', callback);
            callback();
        }, { passive: true });
    },
    update: (el, { value }): void => {
        EventBus.$off('windowResize', callback);
        EventBus.$off('orientationChange', callback);
        el.style.removeProperty('fontSize');
        Vue.nextTick(() => {
            const params = captureInitialParams(el, value);
            callback = keepRatioOnResize(el, params);
            EventBus.$on('windowResize', callback);
            EventBus.$on('orientationChange', callback);
            callback();
        });

    },
    unbind: (): void => {
        EventBus.$off('windowResize', callback);
        EventBus.$off('orientationChange', callback);
    },
};

export default keepRatio;
